var map = {
	"./Slide1.PNG": 5036,
	"./Slide10.PNG": 9190,
	"./Slide11.PNG": 4799,
	"./Slide12.PNG": 6740,
	"./Slide13.PNG": 3085,
	"./Slide14.PNG": 8562,
	"./Slide15.PNG": 8267,
	"./Slide16.PNG": 2864,
	"./Slide17.PNG": 2121,
	"./Slide18.PNG": 8734,
	"./Slide19.PNG": 2615,
	"./Slide2.PNG": 1223,
	"./Slide20.PNG": 2487,
	"./Slide21.PNG": 5582,
	"./Slide22.PNG": 1077,
	"./Slide23.PNG": 6492,
	"./Slide24.PNG": 6771,
	"./Slide25.PNG": 1802,
	"./Slide26.PNG": 7153,
	"./Slide27.PNG": 7320,
	"./Slide28.PNG": 2175,
	"./Slide3.PNG": 4302,
	"./Slide4.PNG": 385,
	"./Slide5.PNG": 6056,
	"./Slide6.PNG": 8739,
	"./Slide7.PNG": 4730,
	"./Slide8.PNG": 4061,
	"./Slide9.PNG": 388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3556;